import React, { useState } from 'react';

function BankAccounts() {
  const banks = [
    { name: 'Сбер', tariff: 'Старт', price: 0, priceText: '0 ₽/мес', bonus: '2 месяца бесплатно', service: 'Бесплатное обслуживание', url: 'https://www.sberbank.ru/ru/legal' },
    { name: 'Точка', tariff: 'Лайт', price: 500, priceText: '500 ₽/мес', bonus: 'Бесплатные платежи физлицам', service: 'Быстрое открытие счёта', url: 'https://tochka.com' },
    { name: 'Тинькофф', tariff: 'Простой', price: 490, priceText: '490 ₽/мес', bonus: '3 месяца бесплатно', service: 'Онлайн-банк 24/7', url: 'https://www.tinkoff.ru/business' },
    { name: 'ВТБ', tariff: 'На старте', price: 0, priceText: '0 ₽/мес', bonus: 'Бесплатный выпуск бизнес-карты', service: 'Счета для госзакупок', url: 'https://www.vtb.ru/business' },
    { name: 'Альфа-Банк', tariff: 'Ноль', price: 0, priceText: '0 ₽/мес', bonus: 'Бесплатные переводы юрлицам', service: 'Лучший мобильный банк', url: 'https://alfabank.ru/sme' },
  ];

  const [selected, setSelected] = useState([]);
  const [showCompare, setShowCompare] = useState(false);
  const [monthlyPayments, setMonthlyPayments] = useState(10);
  const [showForm, setShowForm] = useState(false);
  const [formSent, setFormSent] = useState(false);
  const [formData, setFormData] = useState({ company: '', name: '', phone: '', bank: '' });

  const toggleSelect = (bankName) => {
    setSelected(prev => {
      if (prev.includes(bankName)) {
        return prev.filter(b => b !== bankName);
      }
      if (prev.length >= 3) return prev;
      return [...prev, bankName];
    });
  };

  const compareBanks = banks.filter(b => selected.includes(b.name));
  const minPrice = Math.min(...compareBanks.map(b => b.price));

  const calculateSavings = () => {
    const payments = parseInt(monthlyPayments) || 0;
    const savings = payments * 50;
    return savings;
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const submitForm = (e) => {
    e.preventDefault();
    setFormSent(true);
    setTimeout(() => {
      setFormSent(false);
      setShowForm(false);
      setFormData({ company: '', name: '', phone: '', bank: '' });
    }, 3000);
  };

  return (
    <div>
      <h2>Банковские счета (РКО)</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Выберите до 3 банков для сравнения условий
      </p>

      {/* Калькулятор экономии */}
      <div style={{ marginBottom: 20, padding: 16, background: 'rgba(99,102,241,0.1)', borderRadius: 12, border: '1px solid rgba(99,102,241,0.3)' }}>
        <h3 style={{ marginBottom: 8 }}>💰 Калькулятор экономии</h3>
        <p style={{ color: '#94A3B8', fontSize: 13, marginBottom: 12 }}>
          Сколько платежей в месяц вы совершаете? Мы покажем, сколько вы сэкономите с Khepri.
        </p>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <input
            type="number"
            value={monthlyPayments}
            onChange={e => setMonthlyPayments(e.target.value)}
            min="0"
            max="1000"
            style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC', width: 120 }}
          />
          <span style={{ color: '#94A3B8', fontSize: 13 }}>платежей/мес</span>
        </div>
        <div style={{ marginTop: 12, padding: 12, background: '#10B981', color: '#fff', borderRadius: 8, fontSize: 14, fontWeight: 600 }}>
          Ваша экономия: до {calculateSavings().toLocaleString()} ₽/мес
        </div>
      </div>

      {/* Кнопка сравнения */}
      {selected.length > 0 && (
        <div style={{ marginBottom: 16, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => setShowCompare(!showCompare)}
            style={{
              padding: '10px 20px',
              background: '#6366F1',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            {showCompare ? 'Скрыть сравнение' : `Сравнить выбранные (${selected.length})`}
          </button>
          <button
            onClick={() => { setSelected([]); setShowCompare(false); }}
            style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}
          >
            Сбросить
          </button>
          <button
            onClick={() => setShowForm(!showForm)}
            style={{
              padding: '10px 20px',
              background: '#10B981',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            📝 Оставить заявку
          </button>
        </div>
      )}

      {/* Форма заявки */}
      {showForm && !formSent && (
        <div style={{ marginBottom: 20, padding: 20, background: '#1E293B', borderRadius: 12, border: '1px solid #334155' }}>
          <h3 style={{ marginBottom: 12 }}>Заявка на открытие счёта</h3>
          <form onSubmit={submitForm} style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 400 }}>
            <input
              value={formData.company}
              onChange={e => handleFormChange('company', e.target.value)}
              placeholder="Название компании"
              required
              style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }}
            />
            <input
              value={formData.name}
              onChange={e => handleFormChange('name', e.target.value)}
              placeholder="Контактное лицо"
              required
              style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }}
            />
            <input
              value={formData.phone}
              onChange={e => handleFormChange('phone', e.target.value)}
              placeholder="Телефон"
              required
              style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }}
            />
            <select
              value={formData.bank}
              onChange={e => handleFormChange('bank', e.target.value)}
              required
              style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }}
            >
              <option value="">Выберите банк</option>
              {banks.map((b, i) => (
                <option key={i} value={b.name}>{b.name}</option>
              ))}
            </select>
            <button type="submit" style={{ padding: 12, background: '#10B981', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
              Отправить заявку
            </button>
          </form>
        </div>
      )}

      {formSent && (
        <div style={{ marginBottom: 20, padding: 20, background: '#10B981', color: '#fff', borderRadius: 12, textAlign: 'center' }}>
          ✅ Заявка отправлена! Банк свяжется с вами в ближайшее время.
        </div>
      )}

      {/* Таблица банков */}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 20 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Сравнить</th>
            <th style={{ padding: 8 }}>Банк</th>
            <th style={{ padding: 8 }}>Тариф</th>
            <th style={{ padding: 8 }}>Цена</th>
            <th style={{ padding: 8 }}>Бонус</th>
            <th style={{ padding: 8 }}>Ссылка</th>
          </tr>
        </thead>
        <tbody>
          {banks.map((b, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155', background: selected.includes(b.name) ? 'rgba(99,102,241,0.1)' : 'transparent' }}>
              <td style={{ padding: 8 }}>
                <input
                  type="checkbox"
                  checked={selected.includes(b.name)}
                  onChange={() => toggleSelect(b.name)}
                  style={{ width: 18, height: 18, cursor: 'pointer' }}
                />
              </td>
              <td style={{ padding: 8 }}>{b.name}</td>
              <td style={{ padding: 8, color: '#94A3B8' }}>{b.tariff}</td>
              <td style={{ padding: 8 }}>{b.priceText}</td>
              <td style={{ padding: 8, color: '#10B981' }}>{b.bonus}</td>
              <td style={{ padding: 8 }}>
                <a href={b.url} target="_blank" rel="noopener noreferrer" style={{ color: '#6366F1', textDecoration: 'none' }}>
                  Открыть →
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Таблица сравнения */}
      {showCompare && compareBanks.length > 0 && (
        <div style={{ padding: 20, background: '#1E293B', borderRadius: 12, border: '1px solid #334155' }}>
          <h3 style={{ marginBottom: 16 }}>📊 Сравнение банков</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
                <th style={{ padding: 8 }}>Параметр</th>
                {compareBanks.map((b, i) => (
                  <th key={i} style={{ padding: 8 }}>{b.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid #334155' }}>
                <td style={{ padding: 8, color: '#94A3B8' }}>Тариф</td>
                {compareBanks.map((b, i) => (
                  <td key={i} style={{ padding: 8 }}>{b.tariff}</td>
                ))}
              </tr>
              <tr style={{ borderBottom: '1px solid #334155' }}>
                <td style={{ padding: 8, color: '#94A3B8' }}>Цена</td>
                {compareBanks.map((b, i) => (
                  <td key={i} style={{ padding: 8, fontWeight: 600, color: b.price === minPrice ? '#10B981' : '#F8FAFC' }}>
                    {b.priceText} {b.price === minPrice && '✓'}
                  </td>
                ))}
              </tr>
              <tr style={{ borderBottom: '1px solid #334155' }}>
                <td style={{ padding: 8, color: '#94A3B8' }}>Бонус</td>
                {compareBanks.map((b, i) => (
                  <td key={i} style={{ padding: 8, color: '#10B981' }}>{b.bonus}</td>
                ))}
              </tr>
              <tr>
                <td style={{ padding: 8, color: '#94A3B8' }}>Обслуживание</td>
                {compareBanks.map((b, i) => (
                  <td key={i} style={{ padding: 8 }}>{b.service}</td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default BankAccounts;